export default __webpack_public_path__ + "static/gift-cards-7da423346f94c1eb9fddfea663745d20.jpg";